import {call, put, select} from 'redux-saga/effects';
import {deleteBeer} from 'services/beers';
import {setSuccessAC} from 'store/app/appSlice';
import {handleError} from 'store/app/error/saga';

import {deleteBeerACS, getBeersACS} from '../requestAC';

export function* deleteBeerSaga(action: ReturnType<typeof deleteBeerACS>) {
  const {filters} = yield select((state) => state.beers);
  try {
    yield call(deleteBeer, action.payload);
    yield put(getBeersACS(filters));
    yield put(setSuccessAC(`Beer "${action.payload.name}" was successfully deleted.`));
  } catch (error) {
    yield call(handleError, error, 'Could not delete beer.');
  }
}
